import SkillsEditingContainer from './skills_editing_container';

const SkillsEditing = SkillsEditingContainer;
export default SkillsEditing;
